import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { collection, getCountFromServer, getDocs, onSnapshot, orderBy, query, where } from 'firebase/firestore';
import { auth, db } from '../firebase';
import "../App.css";
import Menu from '../panel/Menu';
import moment from 'moment';
import { Button } from '@mui/material';

function Dashboard() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    const [userData, setUserData] = useState();
    const [bookedrooms, setbookedrooms] = useState(0);
    const [availablerooms, setavailablerooms] = useState(0);
    const [cleaningrooms, setcleaningrooms] = useState(0);
    const [allrooms, setallrooms] = useState(0);

    const [todayCount, settodayCount] = useState(0);
    const [tommCount, settommCount] = useState(0);
    const [thisMonth, setthisMonth] = useState(0);
    const [nextMonth, setnextMonth] = useState(0);

    const [todayCount1, settodayCount1] = useState(0);
    const [tommCount1, settommCount1] = useState(0);
    const [thisMonth1, setthisMonth1] = useState(0);
    const [nextMonth1, setnextMonth1] = useState(0);

    const [webbookings, setwebbookings] = useState([]);
    const [advancebookings, setadvancebookings] = useState([]);
    const [roomTypes, setroomTypes] = useState([]);
    const [roomTypesInventory, setroomTypesInventory] = useState([]);
    const [totalBookingCount, setTotalBookingCount] = useState(0);

    const [roomtypeid, setroomtypeid] = useState("");
    const [checkindate, setcheckindate] = useState(moment().format('YYYY-MM-DD'));
    const [checkindateinv, setcheckindateinv] = useState(moment().format('YYYY-MM-DD'));

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fetchData1()
        });
    }, [userData]);


    const fetchData1 = async () => {
        try {
            if (userData) {
                const today = new Date().toISOString().split('T')[0];
                const tomorrow = moment().add(1, 'days').format('YYYY-MM-DD');
                const firstDateOfMonth = moment().startOf('month').format('YYYY-MM-DD');
                const lastDateOfMonth = moment().endOf('month').format('YYYY-MM-DD');
                const firstDayOfNextMonth = moment().add(1, 'months').startOf('month').format('YYYY-MM-DD');

                // Batch all queries to execute in parallel using Promise.all
                const fetchDataPromises = [
                    // Room status queries
                    getDocs(query(collection(db, 'roomdetails'))), // All rooms
                    getDocs(query(collection(db, 'roomdetails'), where('status', '==', "Booked"))), // Booked rooms
                    getDocs(query(collection(db, 'roomdetails'), where("status", '==', 'Available'))), // Available rooms
                    getDocs(query(collection(db, 'roomdetails'), where("status", '==', 'Cleaning'))), // Rooms being cleaned

                    // Today's bookings
                    getDocs(query(collection(db, 'websitebookings'), where('checkindate', '==', today), where('status', '==', 'Paid'))), // Today's check-ins (website bookings)
                    getDocs(query(collection(db, 'advancebookings'), where('checkindate', '==', today), where('status', '==', 'Paid'))), // Today's check-ins (advance bookings)

                    // Tomorrow's bookings
                    getDocs(query(collection(db, 'websitebookings'), where('checkindate', '==', tomorrow), where('status', '==', 'Paid'))), // Tomorrow's check-ins (website bookings)
                    getDocs(query(collection(db, 'advancebookings'), where('checkindate', '==', tomorrow), where('status', '==', 'Paid'))), // Tomorrow's check-ins (advance bookings)

                    // This month's bookings
                    getDocs(query(collection(db, 'websitebookings'), where('checkindate', '>=', firstDateOfMonth), where('checkindate', '<=', lastDateOfMonth), where('status', '==', 'Paid'))), // This month (website)
                    getDocs(query(collection(db, 'advancebookings'), where('checkindate', '>=', firstDateOfMonth), where('checkindate', '<=', lastDateOfMonth), where('status', '==', 'Paid'))), // This month (advance)

                    // Next month's bookings
                    getDocs(query(collection(db, 'websitebookings'), where('checkindate', '>=', firstDayOfNextMonth), where('status', '==', 'Paid'))), // Next month (website)
                    getDocs(query(collection(db, 'advancebookings'), where('checkindate', '>=', firstDayOfNextMonth), where('status', '==', 'Paid'))), // Next month (advance)

                    // Fetch room types
                    getDocs(query(collection(db, 'roomtypes')))
                ];

                const [
                    allRoomsSnapshot,
                    bookedRoomsSnapshot,
                    availableRoomsSnapshot,
                    cleaningRoomsSnapshot,
                    todayWebsiteSnapshot,
                    todayAdvanceSnapshot,
                    tomorrowWebsiteSnapshot,
                    tomorrowAdvanceSnapshot,
                    thisMonthWebsiteSnapshot,
                    thisMonthAdvanceSnapshot,
                    nextMonthWebsiteSnapshot,
                    nextMonthAdvanceSnapshot,
                    roomtypesSnapshot
                ] = await Promise.all(fetchDataPromises);

                // Update state with data
                setallrooms(allRoomsSnapshot.size);
                setbookedrooms(bookedRoomsSnapshot.size);
                setavailablerooms(availableRoomsSnapshot.size);
                setcleaningrooms(cleaningRoomsSnapshot.size);
                // Today and tomorrow's bookings
                settodayCount(todayWebsiteSnapshot.size);
                settodayCount1(todayAdvanceSnapshot.size);
                settommCount(tomorrowWebsiteSnapshot.size);
                settommCount1(tomorrowAdvanceSnapshot.size);
                // This and next month's bookings
                setthisMonth(thisMonthWebsiteSnapshot.size);
                setthisMonth1(thisMonthAdvanceSnapshot.size);
                setnextMonth(nextMonthWebsiteSnapshot.size);
                setnextMonth1(nextMonthAdvanceSnapshot.size);
                // Room types
                const roomtypesData = roomtypesSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
                setroomTypes(roomtypesData);
            }
        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
            console.error(error.message);
        }
    };


    const getReport = async () => {

        if (!roomtypeid || !checkindate) {
            Toast.fire({ icon: "error", title: 'Please select Date & Room Type' });
            return;
        }

        // WEBSITE BOOKINGS
        const q1 = query(
            collection(db, 'websitebookings'),
            where('checkindate', '==', checkindate),
            where('rtypeid', '==', roomtypeid),
            where('status', '==', 'Paid')
        );

        onSnapshot(q1, (querySnapshot) => {
            setwebbookings(
                querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                }))
            );
        });


        // ADVANCE BOOKINGS
        const q2 = query(
            collection(db, 'advancebookings'),
            where('checkindate', '==', checkindate),
            where('status', '==', 'Paid')
        );

        onSnapshot(q2, (querySnapshot) => {

            const filteredBookings = querySnapshot.docs
                .map(doc => {

                    const data = doc.data();

                    // FILTER ONLY SELECTED ROOM TYPE
                    const filteredRooms = (data.rooms || []).filter(
                        room => room.rtypeid === roomtypeid
                    );

                    // SKIP BOOKING IF NO ROOM MATCH
                    if (filteredRooms.length === 0) return null;

                    return {
                        id: doc.id,
                        ...data,
                        rooms: filteredRooms,           // only selected rooms
                        noofrooms: filteredRooms.length // correct room count
                    };
                })
                .filter(Boolean); // remove null

            setadvancebookings(filteredBookings);

        });
    };
    // Declare a useState for storing the total sum of all bookings

    const getRtypeReport = () => {
        if (!checkindateinv) {
            Toast.fire({ icon: "error", title: 'Please select Checkin Date' });
            return;
        }

        const q = query(collection(db, 'roomtypes'), orderBy('createdAt', 'asc'));
        onSnapshot(q, (querySnapshot) => {
            const roomtypesData = querySnapshot.docs.map(doc => ({
                id: doc.id,
                data: doc.data(),
                webBookingCount: 0, // Initialize the count for website bookings
                advanceBookingCount: 0 // Initialize the count for advance bookings
            }));

            // Fetch website bookings
            const q1 = query(collection(db, 'websitebookings'), where('checkindate', '==', checkindateinv), where('status', '==', 'Paid'));
            onSnapshot(q1, (webSnapshot) => {
                const webBookings = webSnapshot.docs.map(doc => doc.data());

                // Fetch advance bookings
                const q2 = query(collection(db, 'advancebookings'), where('checkindate', '==', checkindateinv), where('status', '==', 'Paid'));
                onSnapshot(q2, (advanceSnapshot) => {
                    const advanceBookings = advanceSnapshot.docs.map(doc => doc.data());

                    // Initialize total booking count
                    let totalBookings = 0;

                    // Map the roomtypes to include booking counts
                    const updatedRoomtypes = roomtypesData.map(roomtype => {
                        // Count website bookings for this roomtype
                        const webBookingCount = webBookings.filter(booking => booking.rtypeid === roomtype.id).length;

                        // Count advance bookings for this roomtype
                        const advanceBookingCount = advanceBookings.filter(booking => {
                            if (booking.rooms) {
                                if (Array.isArray(booking.rooms)) {
                                    return booking.rooms.some(room => room.rtypeid === roomtype.id);
                                }
                                return booking.rooms.rtypeid === roomtype.id;
                            }
                            return false;
                        }).length;

                        // Calculate total bookings for this roomtype
                        const allBookingCount = webBookingCount + advanceBookingCount;

                        // Add to the running total of all bookings
                        totalBookings += allBookingCount;

                        return {
                            ...roomtype,
                            webBookingCount,
                            advanceBookingCount,
                            allBookingCount
                        };
                    });

                    // Update state with roomtypes and total bookings
                    setroomTypesInventory(updatedRoomtypes);
                    setTotalBookingCount(totalBookings); // Set the total sum in state
                });
            });
        });
    };

    const connectScale = async () => {

        try {

            const port = await navigator.serial.requestPort();

            await port.open({
                baudRate: 2400,
                dataBits: 8,
                stopBits: 1,
                parity: "none"
            });

            console.log("Connected:", port);

            const reader = port.readable.getReader();
            const decoder = new TextDecoder();

            let buffer = "";

            while (true) {

                const { value, done } = await reader.read();

                if (done) break;

                if (value) {

                    buffer += decoder.decode(value);

                    if (buffer.includes("\r") || buffer.includes("\n")) {

                        const cleaned = buffer
                            .replace(/\u0002/g, "") // remove STX
                            .replace(/\u0003/g, "") // remove ETX
                            .replace(/[^\d.]/g, "") // keep numbers only
                            .trim();

                        console.log("Weight:", cleaned);

                        buffer = "";

                    }
                }
            }


        } catch (err) {

            console.error("Serial error:", err);

        }

    };

    return (
        <div>
            <Menu />
            <div className="content-wrapper" style={{ backgroundColor: '#fff' }}>
                <section className="content"><br />
                    {/* <div style={{ padding: 20 }}>
                        <Button
                            variant="contained"
                            onClick={connectScale}
                        >
                            Connect Weighing Scale
                        </Button>
                    </div> */}
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-3 col-6">
                                <a href="online-bookings/todays">
                                    <div className="small-box" style={{ backgroundColor: "#00b09eff", color: "white" }}>
                                        <div className="inner">
                                            <h3>{todayCount + todayCount1}</h3>
                                            <p>Today's Bookings</p>
                                        </div>
                                        <div className="icon">
                                            <i className="fas fa-users" />
                                        </div>
                                        <a href="online-bookings/todays" className="small-box-footer" style={{ color: "white" }}>
                                            More info <i className="fas fa-arrow-circle-right"></i>
                                        </a>
                                    </div>
                                </a>
                            </div>
                            <div className="col-lg-3 col-6">
                                <a href="online-bookings/tommorrows">
                                    <div className="small-box" style={{ backgroundColor: "rgb(232, 0, 0)", color: "white" }}>
                                        <div className="inner">
                                            <h3>{tommCount + tommCount1}</h3>
                                            <p>Tomorrow's Bookings</p>
                                        </div>
                                        <div className="icon">
                                            <i className="fas fa-users" />
                                        </div>
                                        <a href="online-bookings/tommorrows" className="small-box-footer" style={{ color: "white" }}>
                                            More info <i className="fas fa-arrow-circle-right"></i>
                                        </a>
                                    </div>
                                </a>
                            </div>
                            <div className="col-lg-3 col-6">
                                <a href="online-bookings/thismonth">
                                    <div className="small-box" style={{ backgroundColor: "#593069ff", color: "white" }}>
                                        <div className="inner">
                                            <h3>{thisMonth + thisMonth1}</h3>
                                            <p>This Month Bookings</p>
                                        </div>
                                        <div className="icon">
                                            <i className="fas fa-users" />
                                        </div>
                                        <a href="online-bookings/thismonth" className="small-box-footer" style={{ color: "white" }}>
                                            More info <i className="fas fa-arrow-circle-right"></i>
                                        </a>
                                    </div>
                                </a>
                            </div>
                            <div className="col-lg-3 col-6">
                                <a href="online-bookings/nextmonth">
                                    <div className="small-box" style={{ backgroundColor: "#0a619bff", color: "white" }}>
                                        <div className="inner">
                                            <h3>{nextMonth + nextMonth1}</h3>
                                            <p>Future Month Bookings</p>
                                        </div>
                                        <div className="icon">
                                            <i className="fas fa-users" />
                                        </div>
                                        <a href="online-bookings/nextmonth" className="small-box-footer" style={{ color: "white" }}>
                                            More info <i className="fas fa-arrow-circle-right"></i>
                                        </a>
                                    </div>
                                </a>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-3 col-6">
                                <a href="live-booking-rooms">
                                    <div className="small-box" style={{ backgroundColor: "#f67b28ff", color: "white" }}>
                                        <div className="inner">
                                            <h3>{bookedrooms}</h3>
                                            <p>Live Bookings Rooms</p>
                                        </div>
                                        <div className="icon">
                                            <i className="ion ion-person-add"></i>
                                        </div>
                                        <a href="live-booking-rooms" className="small-box-footer" style={{ color: "white" }}>
                                            More info <i className="fas fa-arrow-circle-right"></i>
                                        </a>
                                    </div>
                                </a>
                            </div>
                            <div className="col-lg-3 col-6">
                                <a href="available-rooms">
                                    <div className="small-box" style={{ backgroundColor: "#097a38ff", color: "white" }}>
                                        <div className="inner">
                                            <h3>{availablerooms}</h3>
                                            <p>Available Rooms</p>
                                        </div>
                                        <div className="icon">
                                            <i className="ion ion-person-add"></i>
                                        </div>
                                        <a href="available-rooms" className="small-box-footer" style={{ color: "white" }}>
                                            More info <i className="fas fa-arrow-circle-right"></i>
                                        </a>
                                    </div>
                                </a>
                            </div>
                            <div className="col-lg-3 col-6">
                                <a href="cleaning-rooms">
                                    <div className="small-box" style={{ backgroundColor: "#8c0671ff", color: "white" }}>
                                        <div className="inner">
                                            <h3>{cleaningrooms}</h3>
                                            <p>Cleaning Rooms</p>
                                        </div>
                                        <div className="icon">
                                            <i className="ion ion-person-add"></i>
                                        </div>
                                        <a href="cleaning-rooms" className="small-box-footer" style={{ color: "white" }}>
                                            More info <i className="fas fa-arrow-circle-right"></i>
                                        </a>
                                    </div>
                                </a>
                            </div>
                            <div className="col-lg-3 col-6">
                                <a href="all-rooms">
                                    <div className="small-box" style={{ backgroundColor: "#0a0367ff", color: "white" }}>
                                        <div className="inner">
                                            <h3>{allrooms}</h3>
                                            <p>All Rooms</p>
                                        </div>
                                        <div className="icon">
                                            <i className="ion ion-person-add"></i>
                                        </div>
                                        <a href="all-rooms" className="small-box-footer" style={{ color: "white" }}>
                                            More info <i className="fas fa-arrow-circle-right"></i>
                                        </a>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>

                    <hr />
                    <div className="card card-outline mt-2">
                        <div className="card-body table-responsive" >
                            <div className='row'>
                                <div className='col-sm-3'>
                                    <label>Checkin Date</label>
                                    <input type='date' className='form-control' value={checkindateinv} onChange={(e) => setcheckindateinv(e.target.value)} />
                                </div>
                                <div className='col-sm-2'>
                                    <br />
                                    <button className='btn btn-success' onClick={getRtypeReport}>Show Inventory</button>
                                </div>
                                <div className='col-sm-7'>

                                </div>
                            </div><br />
                            <div className='row'>
                                <div className='col-sm-12'>
                                    <table className='table table-bordered'>
                                        <tr>
                                            <th>Room Type</th>
                                            {
                                                roomTypesInventory.map((item, index) =>
                                                    <th>{item.data.roomtype}</th>
                                                )
                                            }
                                            <th>Total</th>
                                        </tr>
                                        <tr>
                                            <th>No Of Rooms</th>
                                            {
                                                roomTypesInventory.map((item, index) =>
                                                    <th>{parseFloat(item.webBookingCount) + parseFloat(item.advanceBookingCount)}</th>
                                                )
                                            }
                                            <th>{totalBookingCount}</th>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div className="container-fluid">
                        <div className="card card-outline mt-2">
                            <div className="card-body table-responsive" >
                                <div className='row'>
                                    <div className='col-sm-3'>
                                        <label>Select Room</label>
                                        <select className='form-control' value={roomtypeid} onChange={(e) => setroomtypeid(e.target.value)}>
                                            <option></option>
                                            {
                                                roomTypes.map((item, index) =>
                                                    <option key={index} value={item.id}>{item.roomtype}</option>
                                                )
                                            }
                                        </select>

                                    </div>
                                    <div className='col-sm-3'>
                                        <label>Date</label>
                                        <input type='date' className='form-control' value={checkindate} onChange={(e) => setcheckindate(e.target.value)} />
                                    </div>
                                    <div className='col-sm-2'>
                                        <br />
                                        <button className='btn btn-success' onClick={getReport}>Check Bookings</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="card card-outline mt-2">
                            <div className="card-body table-responsive" >
                                <h5>Website Bookings</h5>
                                <table className="table table-bordered table-hover table-striped table-head-fixed">
                                    <thead>
                                        <tr>
                                            <th>Sr No</th>
                                            <th> Trans Id </th>
                                            <th> Name </th>
                                            <th>Mobile </th>
                                            <th>Checkin  </th>
                                            <th>Checkout  </th>
                                            <th>Rooms </th>
                                            <th>Adults </th>
                                            <th>Room Type  </th>
                                            <th style={{ textAlign: "right" }}>Total</th>
                                            <th style={{ textAlign: "right" }}>Discount</th>
                                            <th style={{ textAlign: "right" }}>Paid</th>
                                            <th style={{ textAlign: "right" }}>Remaining</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            webbookings.map((item, num = 1) =>
                                                <tr key={num + 1}>
                                                    <td width="80">{num + 1}</td>
                                                    <td>{item.data.transid}</td>
                                                    <td>{item.data.name}</td>
                                                    <td>{item.data.phone} </td>
                                                    <td>{moment(item.data.checkindate).format('DD/MM/YYYY')}</td>
                                                    <td>{moment(item.data.checkoutdate).format('DD/MM/YYYY')}</td>
                                                    <td>{item.data.noofroom} Rooms</td>
                                                    <td>{item.data.adult} Persons</td>
                                                    <td>{item.data.roomtype} <br /> {item.data.planname} </td>
                                                    <td style={{ textAlign: "right" }}>{item.data.total}</td>
                                                    <td style={{ textAlign: "right" }}>{item.data.discountamount} ({item.data.discount}%)</td>
                                                    <td style={{ textAlign: "right" }}>{item.data.advance}</td>
                                                    <td style={{ textAlign: "right" }}>{item.data.remaining}</td>
                                                </tr>
                                            )}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="card card-outline mt-2">
                            <div className="card-body table-responsive" >
                                <h5>Advance Bookings</h5>
                                <table className="table table-bordered table-hover table-striped table-head-fixed">
                                    <thead>
                                        <tr>
                                            <th>Sr No</th>
                                            <th> Name </th>
                                            <th>Mobile </th>
                                            <th>Checkin  </th>
                                            <th>Checkout  </th>
                                            <th >Rooms </th>
                                            <th>Adults </th>
                                            <th style={{ width: 200 }}>Room Type  </th>
                                            <th style={{ textAlign: "right" }}>Total</th>
                                            <th style={{ textAlign: "right" }}>Paid</th>
                                            <th style={{ textAlign: "right" }}>Remaining</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            advancebookings.map((item, num = 1) =>
                                                <tr key={num + 1}>
                                                    <td width="80">{num + 1}</td>
                                                    <td>{item.customers.custname}</td>
                                                    <td>{item.customers.mobile} </td>
                                                    <td>{moment(item.checkindate).format('DD/MM/YYYY')}</td>
                                                    <td>{moment(item.checkoutdate).format('DD/MM/YYYY')}</td>
                                                    <td>{item.noofrooms} Rooms</td>
                                                    <td>{item.adults} Persons</td>
                                                    <td>
                                                        <div className='row'>
                                                            {item.rooms.map((item1, index) =>
                                                                <span key={index}>{item1.roomtypename}, &nbsp;  </span>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td style={{ textAlign: "right" }}>{item.totalamount}</td>
                                                    <td style={{ textAlign: "right" }}>{item.advance}</td>
                                                    <td style={{ textAlign: "right" }}>{item.remaining}</td>
                                                </tr>
                                            )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
            </div>


        </div>
    )
}

export default Dashboard
